export default "__VITE_ASSET__DA8Ujx$P__"